import React from "react";
import { Button, Tooltip, IconButton, Badge } from "@mui/material";
import { LucideKanbanSquare as DashboardIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

// This component is added to the Email Detail Modal to navigate to Unified Kanban Board
const EmailKanbanButton = ({ email, taskCount = 0 }) => {
  const navigate = useNavigate();

  const handleOpenKanban = () => {
    // Prepare email data for task creation
    const emailData = {
      emailId: email.uid || email.messageId,
      messageId: email.messageId,
      subject: email.subject,
      from: email.from,
      to: email.to,
      date: email.date,
      body: email.body,
      emailAttachments: email.attachments || [],
    };

    // Navigate to the unified Kanban board with email data in state
    navigate("/MainAufgabeBoard", {
      state: {
        createFromEmail: true,
        emailData,
      },
    });
  };

  return (
    <Tooltip title="Aufgabe aus E-Mail erstellen">
      <Button
        onClick={handleOpenKanban}
        variant="contained"
        startIcon={
          <Badge badgeContent={taskCount} color="secondary">
            <DashboardIcon className="h-5 w-5" />
          </Badge>
        }
        className="bg-purple-600 hover:bg-purple-700 text-white"
        sx={{
          backgroundColor: "#9333ea",
          "&:hover": {
            backgroundColor: "#7e22ce",
          },
        }}
      >
        Aufgabe erstellen
      </Button>
    </Tooltip>
  );
};

export default EmailKanbanButton;
